export const buildColumns = (columnDefinitions, hide) => {
    return Object.keys(columnDefinitions)
        .filter(c => !hide.includes(c))
        .map(c => columnDefinitions[c]);
};
